const COLS = [
  ["name", "Setup"], ["tagline", "Best for"], ["saunaType", "Sauna type"],
  ["heaterType", "Heater type"], ["capacity", "Capacity"], ["placement", "Indoor / outdoor"],
  ["recoveryAddOn", "Recovery add-on"], ["whiteGlove", "White-glove"],
];

export function ComparisonTable({ rows }) {
  if (!rows?.length) return null;
  const cell = (r, key) =>
    key === "name" ? r.name : key === "tagline" ? r.tagline : r[key] || "—";

  return (
    <div data-testid="comparison-table" className="overflow-x-auto rounded-xl border border-white/10">
      <table className="w-full text-sm min-w-[680px]">
        <thead>
          <tr className="bg-espresso/80">
            {COLS.map(([k, label]) => (
              <th key={k} className="text-left px-4 py-3 text-gold/80 font-medium text-xs uppercase tracking-wider whitespace-nowrap">
                {label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((r, i) => (
            <tr key={r.id} className={`border-t border-white/10 ${i === 0 ? "bg-gold/5" : ""}`}>
              {COLS.map(([k]) => (
                <td key={k} className={`px-4 py-3 align-top ${k === "name" ? "font-serif text-cream" : "text-cream/75"}`}>
                  {cell(r, k)}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
